import { apiRequest } from 'api/apiRequest'
import { getCurrentLanguage } from '../../translation'

const createSupportTicket = (values) => {
  const params = {
    ...values,
    language: getCurrentLanguage(),
  }

  return apiRequest('/v1/support/ticket/create', { error: { message: 'ERROR' } }).post(
    params
  )
}

const createSalesTicket = (values) => {
  const params = {
    ...values,
    language: getCurrentLanguage(),
  }

  return apiRequest('/v1/sales/ticket/create', { error: { message: 'ERROR' } }).post(
    params
  )
}

const createRequestAccessTicket = (values) => {
  const params = {
    ...values,
    language: getCurrentLanguage(),
  }

  return apiRequest('/v1/request-access/ticket/create', {
    error: { message: 'ERROR' },
  }).post(params)
}

const createTrialTicket = (values) => {
  const params = {
    ...values,
    language: getCurrentLanguage(),
  }

  return apiRequest('/v1/payment/subscription/ticket/create', {
    error: { message: 'ERROR' },
  }).post(params)
}

const getTrialTicket = () => apiRequest('/v1/payment/subscription/ticket').get()

export const contactApi = {
  createSupportTicket,
  createSalesTicket,
  createRequestAccessTicket,
  createTrialTicket,
  getTrialTicket,
}
